<!-- 订单信息 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header   flex flexColumn">
        <div class="head-title borderB">
          <div class="text">订单信息</div>
        </div>
        <div class="headSearch Fs14">
          <div class="headSearch-left">
            <div class="Search-condition">
              <div class="form-data group">
                <span>手机号码：</span>
                <el-input
                  clearable
                  v-model="SearchForm.tel"
                  size="mini"
                  placeholder=""
                ></el-input>
              </div>
              <!-- <div class="form-data group">
                <span>区域地址：</span>
                <el-cascader
                  size="mini"
                  :options="options"
                  v-model="SearchForm.selectedOptions"
                  @change="cascaderChange"
                >
                </el-cascader>
              </div> -->
              <div class="form-data group">
                <span>是否催单：</span>
                <el-select
                  clearable
                  size="mini"
                  v-model="SearchForm.cuidan"
                  placeholder="请选择"
                >
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </div>
            </div>
            <div class="Search-condition">
              <div class="form-data group">
                <span>下单时间：</span>
                <el-date-picker
                  size="mini"
                  v-model="SearchForm.time"
                  type="datetimerange"
                  value-format="timestamp"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
              <div class="form-data group">
                <span>订单状态：</span>
                <el-select
                  clearable
                  size="mini"
                  v-model="SearchForm.payTypes"
                  placeholder="请选择订单状态"
                >
                  <el-option
                    v-for="item in optionType"
                    :key="item.type"
                    :label="item.label"
                    :value="item.type"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="form-data group">
                <el-button
                  @click="GetIndentList"
                  round
                  type="primary"
                  size="mini"
                  >搜索</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <el-table
          height="calc(100vh - 330px)"
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="IndentList.list"
          style="width: 100%"
        >
          <el-table-column prop="id" label="#"> </el-table-column>
          <el-table-column label="订单时间" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.dingdanshijian | filterTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="订单用户" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
              <el-link class="link" style="margin-left: 10px;"
                :underline="false" type="primary" icon="el-icon-chat-dot-round" @click="chatBut(scope.row)"></el-link>
            </template>
          </el-table-column>
          <el-table-column prop="tel" label="手机号" width="120">
          </el-table-column>
          <el-table-column prop="indentname" label="商品名" width="150">
          </el-table-column>
          <el-table-column label="订单状态" width="180">
            <template slot-scope="scope">
              <span
                style="color:#c50000"
                v-if="
                  scope.row.payType === 600 ||
                    scope.row.payType === 900 ||
                    scope.row.payType === 1000 ||
                    scope.row.payType === 1100 ||
                    scope.row.payType === 1400 ||
                    scope.row.payType === 1500 ||
                    scope.row.payType === 1900 ||
                    scope.row.payType === 2300 ||
                    scope.row.payType === 2700 ||
                    scope.row.payType === 3000
                "
                >{{ scope.row.payType | filterPayType }}</span
              >
              <span v-else>{{ scope.row.payType | filterPayType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="outTradeNo" label="订单号" width="150">
          </el-table-column>
          <el-table-column prop="payTypes" label="支付方式" width="150">
          </el-table-column>
          <el-table-column prop="indentprice" label="金额"> </el-table-column>
          <el-table-column label="服务人员" width="120">
            <template slot-scope="scope">
              {{ scope.row.server }}
            </template>
          </el-table-column>
          <el-table-column prop="memberAddress" width="220" label="服务地址">
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="240">
            <template slot-scope="scope">
              <div class="operate">
                <!-- <el-link
                  class="link"
                  v-if="
                    scope.row.payType === 1200 ||
                      scope.row.payType === 1300 ||
                      scope.row.payType === 1400 ||
                      scope.row.payType === 1500 ||
                      scope.row.payType === 1800 ||
                      scope.row.payType === 1900 ||
                      scope.row.payType === 200 ||
                      scope.row.payType === 2300 ||
                      scope.row.payType === 2700 ||
                      scope.row.payType === 3000 ||
                      scope.row.payType === 600
                  "
                  :underline="false"
                  type="primary"
                  @click="retreatBut(scope.row)"
                  >退单</el-link> -->
                <el-popconfirm
                  v-if="(scope.row.payType === 100 || scope.row.payType === 1200) && (scope.row.server != null)"
                  style="padding-left:10px"
                  @confirm="jiedanBut(scope.row)"
                  title="操作后无法修改，确定接单吗？">
                  <el-link slot="reference" :underline="false" type="primary">接单</el-link>
                </el-popconfirm>
                <el-link
                  class="link"
                  v-if="(scope.row.payType === 100 ||scope.row.payType === 200 || scope.row.payType === 1200|| scope.row.payType === 1300) && (scope.row.server === null)"
                  :underline="false"
                  type="primary"
                  @click="deliveryBut(scope.row)"
                  >指派</el-link>
                <el-popconfirm
                  v-if="
                    scope.row.payType === 1100 ||
                      scope.row.payType === 1400 ||
                      scope.row.payType === 1500 ||
                      scope.row.payType === 1900 ||
                      scope.row.payType === 2300 ||
                      scope.row.payType === 2700 ||
                      scope.row.payType === 3000 ||
                      scope.row.payType === 600 ||
                      scope.row.payType === 900
                  "
                  style="padding-left:10px"
                  @confirm="cashBut(scope.row)"
                  title="操作后无法修改，确定继续吗？">
                  <el-link slot="reference" :underline="false" type="primary">现金支付</el-link>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="Pagination flex">
          <div class="text">
            <span>共{{ IndentList.total }}条记录，</span>
            <span class="pageNum">{{ IndentList.pageNum }}</span>
            <span>/{{ IndentList.pages }}页</span>
          </div>
          <el-pagination
            v-if="IndentList !== ''"
            @current-change="handleCurrentChange"
            :current-page.sync="IndentList.pageNum"
            :page-size="IndentList.pageSize"
            layout="prev, pager, next, jumper"
            :total="IndentList.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  apiGetIndentList,
  apiChangeIndent,
  apiGetServerList,
  apiGetServerWorkTime
} from '@/api/orderManage'

import AMap from 'AMap'
import { apiChatSessionOpen } from '@/api/chat'
import { regionDataPlus } from 'element-china-area-data' // 引入区域三级联动https://www.npmjs.com/package/element-china-area-data
import Transfer from '@/utils/transfer'
let that
export default {
  name: '',
  props: [''],
  data() {
    return {
      IndentList: '', // 列表
      options: regionDataPlus, // 区域省列表
      pages: {
        page: 1, // 页数
        size: 50
      },
      optionType: [
        { type: '100,200,800,1200,1300', label: '待服务订单' },
        { type: '600,900,1100,1400,1500,1900', label: '待付款订单' },
        { type: '400,1200,1300,1800,2800', label: '已服务订单' },
        { type: '300', label: '待评价订单' }
      ],
      selectedOptions: [],
      SearchForm: {
        tel: '',
        selectedOptions: '',
        time: '',
        cuidan: '',
        payTypes: ''
      }, // 搜索条件
      //获取主面板列表信息，下文会做进一步介绍
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    that = this
    this.SearchForm.payTypes = "100,200,800,1200,1300";
    this.GetIndentList()
  },

  methods: {
    // 搜索
    SearchBut() {
      // if (
      //   this.SearchForm.tel === '' &&
      //   this.SearchForm.selectedOptions === '' &&
      //   this.SearchForm.time === '' &&
      //   this.SearchForm.cuidan === ''
      // ) {
      //   this.$Me('搜索内容条件不得低于一个！')
      //   return
      // }
      // if (this.SearchForm.time === null) {
      //   this.SearchForm.time = []
      // }
    },
    // 列表-接单
    jiedanBut(row) {
      let newPay
      // 对照接口文档订单状态表
      // 因为不同场景下支付完成后的状态改变不同
      switch (row.payType) {
        case 100:
          newPay = 200
          break
        case 1200:
          newPay = 1300
          break
        default:
          alert('没有符合要求的订单')
          console.log('没有符合要求的订单')
          break
      }
      apiChangeIndent({
        id: row.id,
        remark: '接单',
        paytype: newPay // 修改为完成订单状态
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          this.GetIndentList()
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
    },
    // 列表-指派
    deliveryBut(row) {
      if(row.cateType == 1) {
        let data = {
          id: row.id,
          payType: row.payType,
          lng: 0,
          lat: 0,
          cateType: row.cateType
        }
        that.$router.push({
          path: "/OrderDesignate2",
          query: {
            info: that.$Base64.encode(JSON.stringify(data))
          }
        })
      } else {
        if(row.memberAddress == null || row.memberAddress == undefined || row.memberAddress == '') {
          this.$message({type: 'error', message: '订单未指定服务地址，请联系补全'})
        } else {
          // this.deliveryData = row
          /** 在public/index.html 中引入高德地图填写key */
          // 地图地质编译-将地址转换成经纬度
          const geocoder = new AMap.Geocoder({
            // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
            city: '江苏'
          })
          console.log(row);
          // console.log(geocoder)
          geocoder.getLocation(row.memberAddress, function(status, result) {
            console.log(status)
            console.log(result)
            if (status === 'complete' && result.info === 'OK') {
              // result中对应详细地理坐标信息
              // console.log(result)
              // location.lng = result.geocodes[0].location.lng
              // location.lat = result.geocodes[0].location.lat
              let data = {
                id: row.id,
                payType: row.payType,
                lng: result.geocodes[0].location.lng,
                lat: result.geocodes[0].location.lat,
                cateType: row.cateType
              }
              that.$router.push({
                path: "/OrderDesignate",
                query: {
                  info: that.$Base64.encode(JSON.stringify(data))
                }
              })
            } else if (status === 'no_data') {
              that.$Me('地址不全，无法指派')
            } else {
              that.$Me('地址不全，无法指派')
            }
          })
          // 地理/逆地理编码
        }
      }
    },
    // 列表-退单
    retreatBut(row) {
      let newPay
      // 对照接口文档订单状态表
      // 因为不同场景下支付完成后的状态改变不同
      switch (row.payType) {
        case 1200:
          newPay = 500 // 退单(按次交钱要退)（取消订单）
          break
        case 1300:
          newPay = 1100 // 按时间选择服务人员取消订单，需要付款。
          break
        case 1500:
          newPay = 500
          break
        case 1800:
          newPay = 2100 // 积分退款
          break
        case 1900:
          newPay = 500
          break
        case 200:
          newPay = 1100
          break
        case 2300:
          newPay = 2500
          break
        case 2700:
          newPay = 200
          break
        case 1100:
          newPay = 500
          break
        case 1000:
          newPay = 500
          break
        default:
          alert('没有符合要求的订单')
          console.log('没有符合要求的订单')
          break
      }
    },
    // 现金支付
    cashBut(row) {
      let newPay
      // 对照接口文档订单状态表
      // 因为不同场景下支付完成后的状态改变不同
      switch (row.payType) {
        case 600:
          newPay = 300
          break
        case 900:
          newPay = 300
          break
        case 3000:
          newPay = 3001
          break
        case 2700:
          newPay = 2800
          break
        case 2300:
          newPay = 2400
          break
        case 1900:
          newPay = 1800
          break
        case 1500:
          newPay = 100
          break
        case 1400:
          newPay = 200
          break
        case 1100:
          newPay = 500
          break
        case 1000:
          newPay = 500
          break
        default:
          alert('没有符合要求的订单')
          console.log('没有符合要求的订单')
          break
      }
      console.log(newPay)

      apiChangeIndent({
        id: row.id,
        paytypes: '现金支付',
        remark: '用于现金支付',
        paytype: newPay // 修改为完成订单状态
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          this.GetIndentList()
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
    },
    // 区域变换时触发
    cascaderChange() {},
    // 分页
    handleCurrentChange(val) {
      this.pages.page = val
      console.log(`当前页: ${val}`)
      this.GetIndentList()
    },
    // 接口
    // 获取订单列表/评价管理
    GetIndentList() {
      apiGetIndentList({
        tel: this.SearchForm.tel,
        area: this.SearchForm.selectedOptions,
        beginTime: this.SearchForm.time[0],
        overTime: this.SearchForm.time[1],
        cuidan: this.SearchForm.cuidan,
        page: this.pages.page,
        pageSize: this.pages.size,
        payTypes: this.SearchForm.payTypes
      }).then(res => {
        if (res.status === 0) {
          this.IndentList = res.data
        }
      })
    },
    // 聊天
    chatBut(row){
      let fromid = localStorage.getItem("uid");
      let toid = "wx-" + row.uid;
      let cs = {
        fromid: fromid,
        toid:  toid,
        type: 'friend',
      };
      apiChatSessionOpen(cs).then(res => {
        if (res.status === 0) {
          Transfer.$emit('chat-open', row);
        }
      })
    },
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.vue {
  padding: 0 10px;
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    .headSearch {
      width: 100%;
      .headSearch-left {
        padding-top: 10px;
        .form-data {
          // span {
          //   width: 90px;
          // }
          .el-cascader {
            width: 200px;
          }
          /deep/ .el-date-picker {
            width: 200px;
          }
          /deep/ .el-date-editor {
            width: 506px;
          }
          /deep/ .el-input,
          .el-select {
            width: 200px;
          }
        }
      }
    }
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;

    /deep/ .el-table .warning-row {
      background: oldlace;
    }
    /deep/ .el-table {
      .operate {
        .link {
          padding-left: 12px;
        }
      }
    }
    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
.dialog {
  .service {
    .choose {
      padding: 10px 0;
      width: 20%;
      .list {
        border: 1px solid #fff;
      }
      .list:hover {
        border: 1px solid #119685;
      }
    }
  }
}
/deep/ .time-data {
  .time-list {
    padding: 10px 0;
    width: 20%;
    border: 1px solid #fff;
  }
  .time-list {
    cursor: pointer;
  }
  .time-list-click {
    border: 1px solid #119685;
  }
}
</style>
